import React from 'react'
import { Alert } from '@barracuda-internal/bds-core'
import { useFormatMessage } from 'lib/localization'

const BASE_I18N_KEY = 'ess.app.error'

const NoDomainPolicyAccessAlert: React.FC = () => {
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  return (
    <Alert severity="error" data-testid="alert-no-domain-policy-access">
      {formatMessage('no_domain_policy_access')}
    </Alert>
  )
}

export default NoDomainPolicyAccessAlert
